import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getColumnList = createAsyncThunk("/column/getColumnList", async (data, { rejectWithValue }) => {
    // const token = localStorage.getItem("authToken");

    try {
        const response = await axios.post(`${baseUrl}columnFormulation/api/v1/search-columnFormulation`, data, {
            headers: {
                // Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        console.log("re response", response);
        return response.data;
    } catch (error) {
        console.error("Error fetching Columns", error);

        // ✅ Handle errors properly
        return rejectWithValue(error.response?.data?.message || "Failed to fetch Columns");
    }
});